import { z } from 'zod';
/** Raisons d'erreur que seul le navigateur constate (docs/produit/metriques.md). */
export const CLIENT_ERROR_REASONS = [
    'network_lost',
    'network_unrecoverable',
    'network_degraded',
    'media_permission_denied',
    'media_device_busy',
    'media_device_not_found',
    'browser_unsupported',
];
export const clientErrorReasonSchema = z.enum(CLIENT_ERROR_REASONS);
/** Corps strict : la raison, rien d'autre. */
export const clientErrorReportSchema = z.object({ reason: clientErrorReasonSchema }).strict();
//# sourceMappingURL=telemetry.js.map